import React, { useMemo } from "react";

export default function Filters({
  users,
  projects,
  selectedUser,
  setSelectedUser,
  selectedProject,
  setSelectedProject,
  period,
  setPeriod,
  include,
  setInclude,
  from,
  setFrom,
  to,
  setTo,
}) {
  const todayISO = useMemo(() => new Date().toISOString().slice(0, 10), []);

  return (
    <div className="spd__filters" role="region" aria-label="Filters">
      <div className="spd__field">
        <label className="spd__label" htmlFor="f-employee">
          Employee
        </label>
        <select
          id="f-employee"
          className="spd__select"
          value={selectedUser}
          onChange={(e) => setSelectedUser(e.target.value)}
        >
          <option value="all">All</option>
          {users.map((u) => (
            <option key={u._id} value={u._id}>
              {u.name}
            </option>
          ))}
        </select>
      </div>

      <div className="spd__field">
        <label className="spd__label" htmlFor="f-project">
          Project (optional)
        </label>
        <select
          id="f-project"
          className="spd__select"
          value={selectedProject}
          onChange={(e) => setSelectedProject(e.target.value)}
        >
          <option value="">All</option>
          {projects.map((p) => (
            <option key={p._id} value={p._id}>
              {p.projectName || p.name}
            </option>
          ))}
        </select>
      </div>

      <div className="spd__field">
        <label className="spd__label" htmlFor="f-period">
          Period
        </label>
        <select
          id="f-period"
          className="spd__select"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        >
          <option value="month">This Month</option>
          <option value="quarter">This Quarter</option>
          <option value="year">This Year</option>
          <option value="ytd">Year to Date</option>
          <option value="lifelong">Lifelong</option>
          <option value="custom">Custom Range</option>
        </select>
      </div>

      <div className="spd__field">
        <label className="spd__label" htmlFor="f-from">
          From
        </label>
        <input
          id="f-from"
          type="date"
          className="spd__input"
          value={from}
          onChange={(e) => setFrom(e.target.value)}
          disabled={period !== "custom"}
          max={todayISO}
        />
      </div>

      <div className="spd__field">
        <label className="spd__label" htmlFor="f-to">
          To
        </label>
        <input
          id="f-to"
          type="date"
          className="spd__input"
          value={to}
          onChange={(e) => setTo(e.target.value)}
          disabled={period !== "custom"}
          max={todayISO}
        />
      </div>

      <div className="spd__field">
        <label className="spd__label" htmlFor="f-include">
          Payload
        </label>
        <select
          id="f-include"
          className="spd__select"
          value={include}
          onChange={(e) => setInclude(e.target.value)}
        >
          <option value="activity">Activity (light)</option>
          <option value="full">Full (charts)</option>
          <option value="none">Minimal</option>
        </select>
      </div>
    </div>
  );
}
